<ion-content>
  <app-challenge-layout>
    <div class="challenge__header" [appBackgroundImage]="learningModule?.imageUrl">
      <span class="challenge__header__locked">
        <ion-icon name="lock-closed"></ion-icon>
        <span class="challenge__header__locked__text" [innerHTML]="learningModule?.name"></span>
      </span>
    </div>
    <div class="challenge__content">
      <span class="challenge__content__title" [innerHTML]="'LEARNING_MODULES.LOCKED_TITLE' | translate"></span>
      <span class="challenge__content__text" [innerHTML]="'LEARNING_MODULES.LOCKED_DESCRIPTION' | translate"></span>
      <div class="challenge__content__buttons --row">
        <ion-button class="button" [innerHTML]="'LEARNING_MODULES.LOCKED_OK_BUTTON' | translate" (click)="dismiss()"></ion-button>
        <ion-button
          class="button --text --dark"
          [innerHTML]="'LEARNING_MODULES.LOCKED_CANCEL_BUTTON' | translate"
          (click)="dismiss()"
        ></ion-button>
      </div>
    </div>
  </app-challenge-layout>
</ion-content>
